import React from 'react';
import { Box, Grid } from '@mui/material';
import SearchFilter from '../../../components/filters/SearchFilter';
import CustomerTypeFilter from './CustomerTypeFilter';

const CustomerListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  onCustomerTypeChange,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');

  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1}>
        <Grid item>
          <CustomerTypeFilter onChange={onCustomerTypeChange} />
        </Grid>
      </Grid>
      <Grid item>
        <Box display="flex" gap={1} justifyContent="flex-end">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CustomerListFilters;
